<template>
    <div class="panel-section">
        <i class="fas fa-times close-button" @click="closePanel"></i>
        <ul class="toolbar-top groups-tabs panel-block-full">
            <li class="tag" v-for="group in $store.state.data.groups" :key="group"
                :class="['group'+group, selectedFilterGroup === group ? 'active' : '']"
                @click="filterGroup(group)">
                {{ $store.state.config.groupNames[group] }}
            </li>
        </ul>
        <div class="panel-block search-block" :class="{'search-fixed-search': searchQuery}">
            <p class="control has-icons-left">
                <label>
                    <input class="input is-small"
                           type="text"
                           :placeholder="$t('device_list.search')"
                           v-model="searchQuery"
                           v-on:input="searchQuery = $event.target.value">
                </label>
                <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span>
            </p>
        </div>
        <div ref="devicesList" class="device-list" :class="{'search-fixed-list': searchQuery}">
            <perfect-scrollbar>
                <div v-for="device in filteredDevices" :key="device.id">
                        <a :id="'device-'+device.id" class="panel-block device-row"
                           :class="'group'+device.group" @click="selectDevice(device)">
                            <div class="icon status-icon">
                                <i class="fas fa-circle"
                                   :class="[$store.state.config.deviceStatusClass[device.state]]"
                                   aria-hidden="true">
                                </i>
                            </div>
                            <div class="device-row-title" :title="device.label">
                                {{ device.label }}
                            </div>
                            <div class="device-row-icon">
                                <i class="fas fa-plug fa-sm icon-danger"
                                   v-show="device.batteryWarning" aria-hidden="true">
                                </i>
                            </div>
                            <div class="device-row-icon">
                                <i class="fas fa-lock fa-sm"
                                    :class="{'icon-warning': alarmActive(device)}"
                                    v-show="device.moveAlarmSettings.alarm.find(item => item.type === 'continuous').enabled || device.moveAlarmSettings.alarm.find(item => item.type === 'limited').enabled"
                                    aria-hidden="true"
                                    :title="alarmActive(device) ? $t('alarm.alarm_active') : $t('alarm.alarm_enabled_inactive')">
                                </i>
                            </div>
                            <div class="device-row-time">
                                {{ device.lastTime | moment("DD. M. YYYY, HH:mm:ss") }}
                            </div>
                        </a>
                    </div>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeviceListPanel',
    data() {
        return {
            searchQuery: '',
            selectedFilterGroup: -1
        };
    },
    methods: {
        selectDevice(device) {
            this.$store.dispatch('selectDevice', device);
        },
        filterGroup(group) {
            this.selectedFilterGroup = this.selectedFilterGroup === group ? -1 : group;
        },
        closePanel() {
            this.$store.dispatch('devicePanelOpen', false);
        },
        alarmActive(device) {
            return this.$store.getters.deviceAlarmActive(device);
        }
    },
    computed: {
        filteredDevices: function() {
            let nameReg = new RegExp(this.searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi');
            let filtered = [];
            for (let d of this.$store.state.data.devices) {
                if ((d.label.match(nameReg) || d.label2.match(nameReg)) && (this.selectedFilterGroup < 0 || d.group === this.selectedFilterGroup)) {
                    filtered.push(d);
                }
            }
            filtered.sort(function(a, b) {
                if (a.state !== b.state) {
                    return a.state > 1 ? -1 : 1;
                } else {
                    return a.label < b.label ? -1 : 1;
                }
            });
            return filtered;
        }
    }
};
</script>

<style lang="scss">
    .control.has-icons-left .icon, .input {
        height: 2em;
    }

    .groups-tabs {
        height: 2.2em;
        font-size: 1em;
        background-color: $panel-black;
        display: flex;
        flex-direction: row;

        .tag {
            margin: 0 0.1em;
            padding: 0 0.6em;
            height: 2.2em;
            background-color: #303a3a;
            cursor: pointer;
            border-bottom: 2px solid;
            min-width: 30px;
        }
    }

    .panel-block-full {
        display: flex;
    }

    .panel-block.search-block {
        width: 100%;
        background-color: #222323;
        border: none;
        z-index: 1;
        padding-right: 0.5em;
        .input {
            border: none;
            box-shadow: none;
            background-color: $panel-front;
            color: $off-white;

            &::placeholder {
                color: $icon-light;
            }
        }

        .icon {
            color: $icon-light;
        }

        .input:focus ~ .icon {
            color: $off-white;
        }
    }

    .search-block.search-fixed-search {
        position: fixed;
        -webkit-backface-visibility: hidden;
    }

    .device-list {
        overflow: auto;
        background-color: $panel-black;
        font-size: 0.9em;
        padding-bottom: 5px;
        /*padding-bottom: 2em;*/
        /*margin-bottom: 0.7em;*/
        display: flex;
        flex-direction: column;
        -webkit-overflow-scrolling: touch;

        &.search-fixed-list {
            margin-top: 2.9em;
        }

        .search-row {
            flex: 0 0 auto;
        }

        .panel-block:hover {
            background-color: lighten($panel-black, 5);
        }

        .device-row {
            flex: 0 0 auto;
            border-left: 5px solid;
            display: flex;

            &.group1 {
                border-left-color: $group1;
            }

            &.group2 {
                border-left-color: $group2;
            }

            &.group3 {
                border-left-color: $group3;
            }

            &.group4 {
                border-left-color: $group4;
            }

            &.group5 {
                border-left-color: $group5;
            }

            &.group6 {
                border-left-color: $group6;
            }

            &.group7 {
                border-left-color: $group7;
            }

            &.group8 {
                border-left-color: $group8;
            }

            &.group9 {
                border-left-color: $group9;
            }

            .icon {
                margin-bottom: 1px;
                margin-right: 5px;
            }

            .status-icon {
                font-size: 0.6em;
            }

            .device-row-title {
                flex: 1 1 auto;
                white-space: nowrap;
                overflow-x: hidden;
                text-overflow: ellipsis;
            }

            .device-row-time {
                flex: 0 0 auto;
                margin-left: auto;
                font-size: 0.95em;
                color: $grey-light;
            }

            .device-row-icon {
                min-width: 1em;
                margin: 0 0.4em 0.1em;
            }
        }
    }

    .panel-block {
        padding-right: 1em;
        padding-left: 0.5em;
    }

    .panel-block:first-child, .panel-heading:first-child, .panel-tabs:first-child {
        border-top: 1px solid #343c3d;
    }

    .tag:hover {
        background-color: #8c9b9d;
    }

    .tag.group1 {
        border-bottom-color: $group1;

        &.active {
            background-color: $group1;
        }
    }

    .tag.group2 {
        border-bottom-color: $group2;

        &.active {
            background-color: $group2;
        }
    }

    .tag.group3 {
        border-bottom-color: $group3;

        &.active {
            background-color: $group3;
        }
    }

    .tag.group4 {
        border-bottom-color: $group4;

        &.active {
            background-color: $group4;
        }
    }

    .tag.group5 {
        border-bottom-color: $group5;

        &.active {
            background-color: $group5;
        }
    }

    .tag.group6 {
        border-bottom-color: $group6;

        &.active {
            background-color: $group6;
        }
    }

    .tag.group7 {
        border-bottom-color: $group7;

        &.active {
            background-color: $group7;
        }
    }

    .tag.group8 {
        border-bottom-color: $group8;

        &.active {
            background-color: $group8;
        }
    }

    .tag.group9 {
        border-bottom-color: $group9;

        &.active {
            background-color: $group9;
        }
    }

    @media screen and (max-width: 768px) {
        .device-list {
            .device-row {
                padding-top: 0.8em;
                padding-bottom: 0.8em;
            }
        }
    }

</style>
